import {NatPostResidentCondominiumSelect} from './NatPostResidentCondominiumSelect'
import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'
import {NatPostAdminCondominiumSelect} from './NatPostAdminCondominiumSelect'
import {NatPostAdminOverallSelect} from './NatPostAdminOverallSelect'
import {Nullable} from '../../../../app/TypeHelpers'
import {ApiResponse} from '../../../../network/response/ApiResponse'
import {AdminUserLoginInfo} from '../../login/repository/AdminUserLoginInfo'
import {NatPostResidentLogin} from '../../login/repository/NatPostResidentLogin'

export interface PostResidentCondominiumSelectParams {
    condominiumCd: string
    ridgeCd: string
    roomNumber: string
}

export interface PostAdminCondominiumSelectParams {
    condominiumCd: string
}

export interface ChangeBelongCondominiumGroupResponse {
    authorities: string[]
    mode: string
}

export interface ResidentLoginInfoBean extends NatPostResidentLogin {
    mailAddressPc: string | null
    mailAddressMb: string | null
}

export default class NatSessionRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    // 物件選択(居住者)
    async postResidentCondominiumSelect(requestParams: PostResidentCondominiumSelectParams):
        Promise<NatPostResidentCondominiumSelect> {
        return await this.http.post(`/api/resident/session/condominiumSelect`,
            {
                condominiumCd: requestParams.condominiumCd,
                ridgeCd: requestParams.ridgeCd,
                roomNumber: requestParams.roomNumber,
            },
            ContentType.JSON)
    }

    // 物件選択(管理者)
    async postAdminCondominiumSelect(requestParams: PostAdminCondominiumSelectParams):
        Promise<NatPostAdminCondominiumSelect> {
        return await this.http.post(`/api/admin/session/condominiumSelect`,
            {
                condominiumCd: requestParams.condominiumCd,
            },
            ContentType.JSON,
        )
    }

    // 物件選択(物件選択解除)
    async postAdminOverallSelect(): Promise<NatPostAdminOverallSelect> {
        return await this.http.post(`/api/admin/session/overallSelect`, {}, ContentType.JSON)
    }

    async changeBelongCondominiumGroup(
        condominiumGroupId: number,
    ): Promise<Nullable<ChangeBelongCondominiumGroupResponse>> {
        const response: ApiResponse<ChangeBelongCondominiumGroupResponse> =
            await this.http.put('/api/admin/session/belongCondominiumGroup', {condominiumGroupId})
        return response.details
    }

    async changeBelongCondominiumGroupForResidentSite(
        condominiumGroupId: number,
    ): Promise<Nullable<void>> {
        return await this.http.put('/api/resident/session/belongCondominiumGroup', {condominiumGroupId})
    }

    // セッションの利用サイトを管理サイトに設定
    async postAdminUseSite(): Promise<void> {
        return await this.http.post(`/api/admin/session/useSite`, {}, ContentType.JSON)
    }

    // セッションの利用サイトを居住者サイトに設定
    async postResidentUseSite(): Promise<void> {
        return await this.http.post(`/api/resident/session/useSite`, {}, ContentType.JSON)
    }

    async getLoginStatus(): Promise<string> {
        const response: ApiResponse<string> = await this.http.get('/api/common/session/loginStatus')
        return response.details
    }

    async getChangeLoginSiteToAdminAvailability(): Promise<boolean> {
        const response: ApiResponse<boolean> = await this.http.get('/api/resident/session/changeLoginSiteToAdminAvailability')
        return response.details
    }

    async changeLoginSiteToAdmin(): Promise<AdminUserLoginInfo> {
        const response: ApiResponse<AdminUserLoginInfo> =
            await this.http.put(`/api/resident/session/loginSite`, {})
        return response.details
    }

    async changeLoginSiteToResident(): Promise<Nullable<ResidentLoginInfoBean>> {
        const response: ApiResponse<ResidentLoginInfoBean> =
            await this.http.put(`/api/admin/session/loginSite`, {})
        return response.details
    }

}
